import { useEditorMount } from '@tinycld/core/lib/editor/editor-mount'
import { useOrgHref } from '@tinycld/core/lib/org-routes'
import {
    type DriveItemFileActions,
    useDriveItemFileActions,
} from '@tinycld/drive/hooks/use-drive-item-file-actions'
import { router } from 'expo-router'
import { useCallback } from 'react'

export type WorkbookFileActions = DriveItemFileActions

// Thin wrapper over @tinycld/drive's shared file-actions hook that
// supplies calc's post-trash redirect target.
export function useWorkbookFileActions(workbookId: string): WorkbookFileActions {
    const { capabilities } = useEditorMount()
    const orgHref = useOrgHref()
    const onTrashed = useCallback(() => {
        router.replace(orgHref('calc'))
    }, [orgHref])
    const actions = useDriveItemFileActions({
        itemId: workbookId,
        onTrashed,
        roomKind: 'calc',
    })
    // Guests (no org membership) can't rename/trash/copy/open-in-drive.
    // Return inert handlers so any still-mounted control is a no-op.
    if (!capabilities.canUseFileActions) {
        return {
            rename: () => {},
            makeCopy: () => {},
            exportAsTemplate: () => {},
            moveToTrash: () => {},
            openDriveDetails: () => {},
        }
    }
    return actions
}
